import { useEffect, useState } from 'react';

const DEBUG = -1;

export function useAutoProgress(amount: number, timeout: number) {
  const [activeIndex, setActiveIndex] = useState(DEBUG < 0 ? 0 : DEBUG);

  useEffect(() => {
    if (DEBUG >= 0) {
      return;
    }
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % amount);
    }, timeout);
    return () => clearInterval(interval);
  }, [amount, timeout]);

  return { activeIndex, setActiveIndex };
}
